<template>
  <div class="menu-available">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first">
                <h3>
                  <router-link :to="{ name: 'menu_list'}" class="float-left mr-1 main-link">{{$t('menu.menus')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'menu_edit',  params: { id: id }}" class="float-left mr-1 main-link">{{$t('menu.detail')}}</router-link>
                  / {{$t('menu.day_part')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-card header-tag="header" footer-tag="footer" body-class="p-3" v-if="single.config.opening_hours || single.config.special_date">
        <div slot="header">
          <strong class="uppercase">{{ $t('menu.day_part') }}</strong>
        </div>
        <b-row>
          <!-- Part of Days of Week -->
          <b-col cols="4" v-if="single.config.opening_hours && dataDayPart">
            <b-form-group :label-cols="3" :horizontal="true" v-for="dayPart in dataDayPart" :key="dayPart.day" v-bind:label="$t('common.'+dayPart.day)">
              <div role="group" class="input-group">
                <a href="javascript:void(0)" class="reset-custom" @click="resetTime(dayPart)">
                  {{ $t('banner.reset') }}
                </a>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <b-form-checkbox v-model="dayPart.active" :value="1" :unchecked-value="0"></b-form-checkbox>
                  </div>
                </div>
                <!--<masked-input
                  type="text"
                  name="date"
                  class="form-control col-sm-6 float-left"
                  v-model="opening_times[day].opening"
                  :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                  :guide="true"
                  placeholderChar="_"
                  :showMask="true"
                  :keepCharPositions="true">
                </masked-input>-->
                <date-picker-input
                  className="form-control col-sm-6 float-left"
                  name="date"
                  type="time"
                  v-model="dayPart.opening"
                  :lang="$session.get('lang')"
                  :hasPicker="true"
                  formatInput="HH:mm:ss"
                  formatOutput="HH:mm:ss"
                  :change="(e) => dayPart.opening = e"
                />
                <div class="input-group-append">
                  <div class="input-group-text"><i class="fa fa-minus"></i></div>
                </div>
                <!--<masked-input
                  type="text"
                  name="date"
                  class="form-control col-sm-6 float-left"
                  v-model="opening_times[day].closing"
                  :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                  :guide="true"
                  placeholderChar="_"
                  :showMask="true"
                  :keepCharPositions="true">
                </masked-input>-->
                <date-picker-input
                  className="form-control col-sm-6 float-left"
                  name="date"
                  type="time"
                  v-model="dayPart.closing"
                  :lang="$session.get('lang')"
                  :hasPicker="true"
                  formatInput="HH:mm:ss"
                  formatOutput="HH:mm:ss"
                  :change="(e) => dayPart.closing = e"
                />
              </div>
            </b-form-group>
          </b-col>
          <!-- End of Days of Week -->

          <!-- Part of Special Date -->
          <b-col cols="8" v-if="single.config.special_date">
            <b-form-group :label-cols="11" v-bind:label="$t('menu.exception_date')">
              <table class="table table-bordered table-hover">
                <thead>
                <tr>
                  <th class="hide">{{$t('menu.exception_table_name')}}</th>
                  <th>{{$t('menu.exception_table_date')}}</th>
                  <th>{{$t('menu.exception_table_time')}}</th>
                  <th>{{$t('combo.open')}}</th>
                  <th>{{$t('common.action')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(date, index) in special_dates" :key="date.id">
                  <td class="hide">
                    <b-form-input class="form-control" v-model="special_dates[index].name">
                    </b-form-input>
                  </td>
                  <td>
                    <!--<masked-input
                      type="text"
                      name="date"
                      class="form-control"
                      v-model="special_dates[index].date"
                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                      :guide="true"
                      placeholderChar="_"
                      :showMask="true"
                      :keepCharPositions="true">
                    </masked-input>-->
                    <date-picker-input
                      className="form-control col-sm-6 float-left"
                      name="date"
                      type="date"
                      v-model="special_dates[index].date"
                      :lang="$session.get('lang')"
                      :hasPicker="true"
                      formatInput="DD-MM-YYYY"
                      formatOutput="DD-MM-YYYY"
                      :change="(e) => special_dates[index].date = e"
                    />
                  </td>
                  <td>
                    <div role="group" class="input-group">
                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-6 float-left"
                        v-model="special_dates[index].from"
                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>-->
                      <date-picker-input
                        className="form-control col-sm-6 float-left"
                        name="date"
                        type="time"
                        v-model="special_dates[index].from"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="HH:mm:ss"
                        formatOutput="HH:mm:ss"
                        :change="(e) => special_dates[index].from = e"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                      </div>
                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-6 float-left"
                        v-model="special_dates[index].to"
                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>-->
                      <date-picker-input
                        className="form-control col-sm-6 float-left"
                        name="date"
                        type="time"
                        v-model="special_dates[index].to"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="HH:mm:ss"
                        formatOutput="HH:mm:ss"
                        :change="(e) => special_dates[index].to = e"
                      />
                    </div>
                  </td>
                  <td>
                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="special_dates[index].status" :checked="special_dates[index].status" :value="1" :uncheckedValue="0"/>
                  </td>
                  <td>
                    <b-button class="btn btn-transparent text-main border-radius-4px delete-date" v-on:click="removeSpecialDate(index)" size="sm"><i class="fa fa-trash-o"></i></b-button>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <button type="button" class="btn bg-main border-radius-4px" v-on:click="addSpecialDate"><i class="fa fa-plus"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-form-group>
          </b-col>
          <!-- End of Special Date -->
        </b-row>

        <div slot="footer">
          <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
          <div class="btn-save">
            <button class="btn bg-main border-radius-4px btn-main pl-3 pr-3" v-on:click="saveItem()" v-if="!processing">{{$t('common.save')}}</button>
          </div>
        </div>
      </b-card>
    </div>

  </div>
</template>
<style>
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
  }
</style>
<style scoped>
  .delete-date {
    font-size: 18px;
    font-weight: bold;
  }
  .menu-available .switch.switch-icon{
    margin-top: 5px;
  }

  .menu-available .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .reset-custom {
    margin-right: 10px;
    margin-top: 7px;
    color: #0091FF !important;
  }

  .menu-available .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-available .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-available .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-available .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }

  .menu-available .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .menu-available .btn-save{
    float: right;
    margin-right: 22px;
  }
  .btn-circle {
    border: 1px solid #0091ff;
    border-radius: 50%;
    color: #0091ff;
    width: 15px;
    height: 15px;
    text-align: center;
  }
  .close-btn {
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 18px;
    margin-left: 10px;
    color: #2a2c36;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .menu-available .card,
  .menu-available .card header.card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .menu-available .card .card-body {
    padding-top: 0px;
  }
  .topping-search {
    width: 100%;
    display: flex;
    background: #e1e6eb;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 20px;
  }
  .topping-label {
    width: auto;
    padding-right: 20px;
    line-height: 35px;
    font-weight: 600;
  }
  .topping-input {
    flex: 1;
  }
  .topping-input .input-group-text {
    background: #fff !important;
    border-right: none !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .topping-input input {
    border-left: none !important;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .selected-topping {
    background: #82909b;
    padding: 7px 10px;
    border-radius: 30px;
    margin-right: 15px;
    color: #fff;
    margin-top: 10px;
    float: left;
  }
  .selected-topping.special {
    background: #1cdd6e;
  }
  .topping-list {
    width: 100%;
    padding: 20px;
    background: #f5f7f9;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-bottom: 20px;
  }
  .topping-item {
    padding: 5px 15px;
    cursor: pointer;
  }
  .topping-list span {
    border-radius: 20px;
    padding: 2px 10px 2px 5px;
  }
  .topping-list span.special {
    background-color: #1cdd6e;
  }
</style>
<script>
import cSwitch from '../../../components/Switch'
import MaskedInput from 'vue-text-mask'
import DatePickerInput from '@/components/Partials/DatePickerInput'

let vm = null

export default {
  name: 'MenuAvailable',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    cSwitch,
    MaskedInput,
    DatePickerInput
  },
  data: function () {
    return {
      daysOfWeek: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'pub'],
      single: this.$store.getters.config.gms.menu,
      item: this.$session.get('single'),
      special_dates: [],
      opening_times: {},
      default_topping_ids: [],
      extra_topping_ids: [],
      default_topping_key: '',
      extra_topping_key: '',
      default_toppings: {},
      extra_toppings: {},
      source_default_toppings: {},
      source_extra_toppings: {},
      processing: false,
      dataDayPart: []
    }
  },
  methods: {
    addExtraTopping (val) {
      let exist = false
      for (let i in this.extra_topping_ids) {
        if (this.extra_topping_ids[i] == val) {
          exist = true
        }
      }
      if (!exist) {
        this.extra_topping_ids.push(val)
      }
    },
    addDefaultTopping (val) {
      let exist = false
      for (let i in this.default_topping_ids) {
        if (this.default_topping_ids[i] == val) {
          exist = true
        }
      }
      if (!exist) {
        this.default_topping_ids.push(val)
      }
    },
    resetTime(dayPart) {
      dayPart.opening = '00:00:00'
      dayPart.closing = '23:59:59'
    },
    removeExtraTopping (val) {
      let extraTopping = []
      for (let i in this.extra_topping_ids) {
        if (this.extra_topping_ids[i] != val) {
          extraTopping.push(this.extra_topping_ids[i])
        }
      }
      this.extra_topping_ids = extraTopping
    },
    removeDefaultTopping (val) {
      let defaultTopping = []
      for (let i in this.default_topping_ids) {
        if (this.default_topping_ids[i] != val) {
          defaultTopping.push(this.default_topping_ids[i])
        }
      }
      this.default_topping_ids = defaultTopping
    },
    /**
     * check check-box of default toppings is check or not
     * @param val
     * @returns {*}
     */
    checkDefaultTopping (val) {
      if (this.default_topping_ids.indexOf(val) >= 0) {
        return val
      }
      return -val
    },
    /**
     * update list default topping ids
     * @param val
     */
    updateDefaultTopping (val) {
      if (val > 0) {
        if (this.default_topping_ids.indexOf(val) < 0) {
          this.default_topping_ids.push(val)
        }
      } else {
        val = Math.abs(val)
        let ids = []
        for (let i in this.default_topping_ids) {
          if (val != this.default_topping_ids[i]) {
            ids.push(this.default_topping_ids[i])
          }
        }
        this.default_topping_ids = ids
      }
    },
    /**
     * check check-box of extra toppings is check or not
     * @param val
     * @returns {*}
     */
    checkExtraTopping (val) {
      if (this.extra_topping_ids.indexOf(val) >= 0) {
        return val
      }
      return -val
    },
    /**
     * update list extra topping ids
     * @param val
     */
    updateExtraTopping (val) {
      if (val > 0) {
        if (this.extra_topping_ids.indexOf(val) < 0) {
          this.extra_topping_ids.push(val)
        }
      } else {
        val = Math.abs(val)
        let ids = []
        for (let i in this.extra_topping_ids) {
          if (val != this.extra_topping_ids[i]) {
            ids.push(this.extra_topping_ids[i])
          }
        }
        this.extra_topping_ids = ids
      }
    },
    /**
     * remove special date from list
     * @param index
     */
    removeSpecialDate (index) {
      let dates = []

      for (let i in this.special_dates) {
        if (i != index) {
          dates.push(this.special_dates[i])
        }
      }

      this.special_dates = dates
    },
    /**
     * add special date to list with default attribute
     */
    addSpecialDate () {
      this.special_dates.push({
        name: '',
        from: '00:00:00',
        to: '23:59:59',
        date: this.$moment().format('DD-MM-YYYY'),
        status: 1,
        active: 1
      })
    },/**
     * convert data format then update item, then back to list page
     */
    saveItem () {
      let special_dates = JSON.parse(JSON.stringify(vm.special_dates))
      for(let i of special_dates){
        i.date = vm.revertDateFormat(i.date)
      }
      for (let i = 0; i < vm.dataDayPart.length; i++) {
        const element = vm.dataDayPart[i];
        vm.opening_times[element.day].opening = element.opening
        vm.opening_times[element.day].closing = element.closing
        vm.opening_times[element.day].active = element.active
      }
      let item = {
        id: vm.item.id,
        uuid: vm.item.uuid,
        product_type: "single",
        opening_times: vm.opening_times,
        special_dates: special_dates
      }
      // call an API to save menu information
      vm.processing = true

      vm.axios.updateDayPart(item, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        let openingTime = {}
        for(let i of response.data.data.opening_times){
          openingTime[i.day] = {
            day: i.day,
            opening: i.opening,
            closing: i.closing,
            active: i.active
          }
        }
        vm.item.opening_times = response.data.data.opening_times
        vm.item.special_dates = response.data.data.special_dates
        vm.$session.set('single',vm.item)
        vm.opening_times = openingTime
        for(let i of  response.data.data.special_dates){
          i.date = vm.convertDateFormat(i.date)
        }
        vm.special_dates = response.data.data.special_dates
        vm._.cloneDeep(vm.opening_times)
        vm.processing = false
      }, function () {
        vm.processing = false
      })
      // this._.cloneDeep(vm.item)
    },
    /**
     * convert date from YYYY-MM-DD to DD-MM-YYYY
     * @param val
     * @returns {*}
     */
    convertDateFormat (val) {
      // val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    /**
     * revert date from DD-MM-YYYY to YYYY-MM-DD
     * @param val
     * @returns {*}
     */
    revertDateFormat (val) {
      let formatDate = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      return formatDate
    },
    getExtraAndDefaultToppingsData () {
      // set selected value for default and extra values
      vm.default_topping_ids = []
      vm.extra_topping_ids = []

      for (let i = 0; i < vm.item.toppings.default.length; i++) {
        vm.default_topping_ids.push(vm.item.toppings.default[i].topping_id)
      }
      for (let i = 0; i < vm.item.toppings.extra.length; i++) {
        vm.extra_topping_ids.push(vm.item.toppings.extra[i].topping_id)
      }

      // set default and extra toppings for menu
      vm.axios.getExtraAndDefaultToppings(function (response) {
        for (let i in vm.$store.getters.languages) {
          vm.default_toppings[vm.$store.getters.languages[i]] = []
          vm.extra_toppings[vm.$store.getters.languages[i]] = []

          vm.source_default_toppings[vm.$store.getters.languages[i]] = {}
          vm.source_extra_toppings[vm.$store.getters.languages[i]] = {}

          for (let t in response.data.data.items.default) {
            let it = response.data.data.items.default[t]
            if (it.name[vm.$store.getters.languages[i]] && it.name[vm.$store.getters.languages[i]] != undefined && it.name[vm.$store.getters.languages[i]] != null) {
              let item = {
                'id': it.id,
                'text': it.name[vm.$store.getters.languages[i]],
                'special': it.special
              }
              // debugger
              vm.$set(vm.default_toppings[vm.$store.getters.languages[i]], t, item)
              vm.source_default_toppings[vm.$store.getters.languages[i]]['id_' + it.id] = item
            }
          }

          // process data for extra value
          for (let t in response.data.data.items.extra) {
            let it = response.data.data.items.extra[t]
            if (it.name[vm.$store.getters.languages[i]] && it.name[vm.$store.getters.languages[i]] != undefined && it.name[vm.$store.getters.languages[i]] != null) {
              let item = {
                'id': it.id,
                'text': it.name[vm.$store.getters.languages[i]],
                'special': it.special
              }
              // debugger
              vm.$set(vm.extra_toppings[vm.$store.getters.languages[i]], t, item)
              vm.source_extra_toppings[vm.$store.getters.languages[i]]['id_' + it.id] = item
            }
          }
        }
        vm.$forceUpdate('default_toppings')
        vm.$forceUpdate('extra_toppings')
        vm.$forceUpdate('source_default_toppings')
        vm.$forceUpdate('source_extra_toppings')
      })
    }
  },
  created: function () {
    vm = this
    for (let i in vm.daysOfWeek) {
      vm.opening_times[vm.daysOfWeek[i]] = {
        day: vm.daysOfWeek[i],
        opening: '00:00:00',
        closing: '23:59:59',
        active: 1
      }

      vm.dataDayPart.push({
        day: vm.daysOfWeek[i],
        opening: '00:00:00',
        closing: '23:59:59',
        active: 1
      })

      for (let i in vm.item.opening_times) {
        if (vm.item.opening_times[i].day == vm.daysOfWeek[i]) {
          vm.opening_times[vm.item.opening_times[i].day] = {
            day: vm.item.opening_times[i].day,
            opening: vm.item.opening_times[i].opening,
            closing: vm.item.opening_times[i].closing,
            active: vm.item.opening_times[i].active
          }
        }
      }
    }
    for (let i = 0; i < vm.dataDayPart.length; i++) {
      vm.dataDayPart[i].active = vm.opening_times[vm.dataDayPart[i].day].active
      vm.dataDayPart[i].opening = vm.opening_times[vm.dataDayPart[i].day].opening
      vm.dataDayPart[i].closing = vm.opening_times[vm.dataDayPart[i].day].closing
    }

    if (vm.item.special_dates == null) {
      vm.special_dates = []
    } else {
      vm.special_dates = vm._.cloneDeep(vm.item.special_dates)
      for (let i in vm.special_dates) {
        vm.special_dates[i].date = vm.convertDateFormat(vm.special_dates[i].date)
      }
    }
  },
  mounted: function () {
    vm.getExtraAndDefaultToppingsData()
  },
  watch: {
    default_topping_key: function () {
      let default_toppings = []
      for (let t in vm.source_default_toppings[vm.$session.get('lang')]) {
        if (vm.source_default_toppings[vm.$session.get('lang')][t].text.indexOf(vm.default_topping_key) >= 0) { // existed
          default_toppings.push(vm.source_default_toppings[vm.$session.get('lang')][t])
        }
      }
      vm.default_toppings[vm.$session.get('lang')] = default_toppings
    },
    extra_topping_key: function () {
      let extra_toppings = []
      for (let t in vm.source_extra_toppings[vm.$session.get('lang')]) {
        if (vm.source_extra_toppings[vm.$session.get('lang')][t].text.indexOf(vm.extra_topping_key) >= 0) { // existed
          extra_toppings.push(vm.source_extra_toppings[vm.$session.get('lang')][t])
        }
      }
      vm.extra_toppings[vm.$session.get('lang')] = extra_toppings
    }
  }
}
</script>

<style scoped>
  .default-topping,
  .extra-topping{
    margin-left: 5px;
    margin-top: 8px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/menu/AvailableForm.vue